import axios from "axios";

import config from "../frontend.config.json";

const BACKEND_ORIGIN = config.BACKEND_ORIGIN;

const SchedulesGroupAPI = {
  getSchedulesGroup: async (token, queryParams = {}) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/schedules-group`,
      headers: { Authorization: token },
      params: { ...queryParams },
    });
  },
  createScheduleGroup: async (token, data) => {
    return await axios({
      method: "POST",
      url: `${BACKEND_ORIGIN}/api/schedules-group`,
      headers: { Authorization: token },
      data,
    });
  },
  updateScheduleGroup: async (token, data) => {
    return await axios({
      method: "PUT",
      url: `${BACKEND_ORIGIN}/api/schedules-group`,
      headers: { Authorization: token },
      data,
    });
  },
  deleteScheduleGroup: async (token, id) => {
    return await axios({
      method: "DELETE",
      url: `${BACKEND_ORIGIN}/api/schedules-group/${id}`,
      headers: { Authorization: token },
    });
  },
};

export default SchedulesGroupAPI;
